import React, { useCallback, useEffect, useState } from 'react';
import { IconCalendarEvent, IconDownload, IconLayoutKanban, IconUsers } from '@tabler/icons-react';
import type { Lead } from '../../../../entities/lead';
import { pb } from '../../../../shared/api/pocketbase';
import { Button } from '../../../../shared/ui/Button';

interface Stats {
  leads: number;
  users: number;
  tasks: number;
}

interface StatisticsRecord {
  users_count: number;
  tasks_count: number;
  jobs_tasks_count: number;
}

const StatsSection: React.FC = () => {
  const [stats, setStats] = useState<Stats | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    pb.collection('statistics').getFirstListItem<StatisticsRecord>('')
      .then(record => {
        setStats({
          leads: record.tasks_count,
          users: record.users_count,
          tasks: record.jobs_tasks_count,
        });
      })
      .catch(() => setStats({ leads: 0, users: 0, tasks: 0 }))
      .finally(() => setLoading(false));
  }, []);

  const handleExportPhones = useCallback(async () => {
    const leads = await pb.collection('tasks').getFullList<Lead>({
      filter: 'phone != ""',
      fields: 'phone,expand.boardId.name',
      expand: 'boardId',
    });
    const rows = leads
      .filter(l => l.phone)
      .map(l => {
        const phone = `"${l.phone!.replace(/"/g, '""')}"`;
        const col = `"${(l.expand?.boardId?.name ?? '').replace(/"/g, '""')}"`;
        return `${phone},${col}`;
      });
    const csv = ['Номер,Колонка', ...rows].join('\n');
    const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'phones.csv';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }, []);

  return (
    <div className="adm-section">
      <div className="adm-section-header adm-section-header-row">
        <div>
          <h2 className="adm-section-title">Статистика</h2>
          <p className="adm-section-sub">Общие показатели системы</p>
        </div>
        <Button variant="adm-add" type="button" onClick={() => { void handleExportPhones(); }}>
          <IconDownload size={15} stroke={2} />Экспорт номеров
        </Button>
      </div>
      {loading ? (
        <div className="adm-loading">Загрузка...</div>
      ) : stats ? (
        <div className="adm-stats-grid">
          <div className="adm-stat-card">
            <div className="adm-stat-icon leads"><IconLayoutKanban size={22} stroke={2} /></div>
            <div className="adm-stat-value">{stats.leads}</div>
            <div className="adm-stat-label">Лидов</div>
          </div>
          <div className="adm-stat-card">
            <div className="adm-stat-icon users"><IconUsers size={22} stroke={2} /></div>
            <div className="adm-stat-value">{stats.users}</div>
            <div className="adm-stat-label">Пользователей</div>
          </div>
          <div className="adm-stat-card">
            <div className="adm-stat-icon tasks"><IconCalendarEvent size={22} stroke={2} /></div>
            <div className="adm-stat-value">{stats.tasks}</div>
            <div className="adm-stat-label">Задач</div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export { StatsSection };
